import { FC } from "react";
import styles from "./index.module.scss";

type SeoContentType = {
  html: string;
};

const SeoContent: FC<SeoContentType> = ({ html }) => {
  if (!html || html.trim() === "") {
    return null;
  }

  return (
    <article
      className="relative flex flex-col"
      id={styles["seo-content"]}
      dangerouslySetInnerHTML={{ __html: html }}
    ></article>
  );
};

export default SeoContent;
